<template>
	<div>
		<CRow>
			<CCol xs="12" lg="12">
				<CCard>
					<CCardHeader>
						<div class="row">
							<CCol sm="6" class="align-self-center">
								<strong>{{ $lang.ai_autoai_interview_plan.crud.edit }}</strong>
							</CCol>
						</div>
					</CCardHeader>
					<CCardBody>
						<CAlert :color="messageColor" closeButton :show.sync="dismissCountDown" fade>
							{{ err_msg }}
						</CAlert>
						<CForm @submit.prevent="onAiAutoAIInterviewPlanUpdate">
							<CRow>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.title }}<required_span/></label>
										<input type="text" :maxlength="maxlength.title" :placeholder="$lang.ai_autoai_interview_plan.form.title" class="form-control" v-model="aiAutoaiInterviewPlan.title" />
										<small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.title.required">{{ $lang.ai_autoai_interview_plan.validation.required.title }}</small>
									</div>
								</CCol>
	
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.type }} <required_span/> </label>
										<v-select id="type" :options="typeOptions" v-model="aiAutoaiInterviewPlan.type" disabled></v-select>
										<small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.type.required">
                                            {{ $lang.ai_autoai_interview_plan.validation.required.type }}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.platform }} <required_span/> </label>
										<v-select id="platform" :options="platformOptions" v-model="aiAutoaiInterviewPlan.platform" multiple></v-select>
										<small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.platform.required">
                                            {{$lang.ai_autoai_interview_plan.validation.required.platform}}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.ai_autoai_interview_plan.form.skuCodeAndroid }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="Android SKU Code" class="form-control" v-model="aiAutoaiInterviewPlan.skuCodeAndroid" />
                                    </div>
                                </CCol>

                                <CCol md="4">
                                    <div class="form-group">
                                        <label class="form__label">{{ $lang.ai_autoai_interview_plan.form.skuCodeIos }}</label>
                                        <input type="text" :maxlength="maxlength.skuCode" placeholder="iOS SKU Code" class="form-control" v-model="aiAutoaiInterviewPlan.skuCodeIos" />
                                    </div>
                                </CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.duration }} <required_span/></label>
										<v-select id="duration" :options="durationOptions" v-model="aiAutoaiInterviewPlan.duration"></v-select>

                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.duration.required">
                                            {{$lang.ai_autoai_interview_plan.validation.required.duration}}
                                        </small>
									</div>
								</CCol>
								<CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.durationValue }} <required_span/></label>
										<input type="text" :maxlength="maxlength.durationValue" :placeholder="$lang.ai_autoai_interview_plan.form.durationValue" class="form-control" v-model="aiAutoaiInterviewPlan.durationValue" />

                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.durationValue.required">
                                            {{$lang.ai_autoai_interview_plan.validation.required.durationValue}}
                                        </small>

										<!-- Min value error -->
                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.durationValue.minValue">
                                        Please enter a value greater than or equal to 1
                                        </small>

                                        <!-- Max value error -->
                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.durationValue.maxValue">
                                        Please enter a value less than or equal to {{ maxV }}
                                        </small>
									</div>
								</CCol>

                                <CCol md="4">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.minutes }} <required_span/></label>
										<input type="text" :maxlength="maxlength.minutes" :placeholder="$lang.ai_autoai_interview_plan.form.minutes" class="form-control" v-model="aiAutoaiInterviewPlan.minutes" />

                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.minutes.required">
                                            {{$lang.ai_autoai_interview_plan.validation.required.minutes}}
                                        </small>
									</div>
								</CCol>
								
								<CCol md="12">
									<div class="form-group">
										<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.description }} <required_span/> </label>
										<textarea :maxlength="maxlength.description" :placeholder="$lang.ai_autoai_interview_plan.form.description" class="form-control" v-model="aiAutoaiInterviewPlan.description" rows="5" />
										
                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.description.maxLength">
                                            Description must not exceed 255 characters.
                                        </small>
                                        <small class="error" v-if="$v.aiAutoaiInterviewPlan.$error && !$v.aiAutoaiInterviewPlan.description.required">{{$lang.ai_autoai_interview_plan.validation.required.description}}</small>
									</div>
								</CCol>
							</CRow>
							<span id="plan_pricing">
								<h4>Plan Price</h4>
								<div v-for="(platformInputs, platformKey) in inputs" :key="platformKey">
									<h5 class="mt-3 text-capitalize">{{ platformKey }}</h5>
									<div v-for="input in platformInputs" :key="input.id" class="inputArea">
										<CRow>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.country }} </label>
													<v-select v-model="input.countryId" :options="countryOptions"></v-select>
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.price }} </label>
													<input type="text" v-model="input.price" class="form-control" :placeholder="$lang.ai_autoai_interview_plan.form.price">
												</div>
											</CCol>
											<CCol md="3">
												<div class="form-group">
													<label class="form__label">{{ $lang.ai_autoai_interview_plan.form.offerPrice }} </label>
													<input type="text" v-model="input.offerPrice" class="form-control" :placeholder="$lang.ai_autoai_interview_plan.form.offerPrice">
												</div>
											</CCol>
											<CCol md="1">
												<div class="form-group">
													<label class="form__label">Has GST? </label><br>
													<input type="checkbox" v-model="input.hasGst"/>
												</div>
											</CCol>
											<CCol md="2">
												<div class="form-group">
													<label class="form__label">Actions</label><br>
													<button type="button" class="btn btn-success" @click="addInput(platformKey)">
														<i class="fa fa-plus"></i>
													</button>&nbsp;
													<button type="button" class="btn btn-danger" @click="subInput(platformKey, input.id)">
														<i class="fa fa-minus"></i>
													</button>
												</div>
											</CCol>
										</CRow>
									</div>
								</div>
							</span>
                        <CRow>
                            <CCol col="6" class="text-left">
                                <CButton color="primary" :disabled="submitted" class="px-4" type="submit">
                                    {{ $lang.common.general.update }}
                                </CButton>
                            </CCol>
                        </CRow>
						</CForm>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";
import VueForm from "vue-form";
import { ServerTable } from "vue-tables-2";
import { required } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import { Maxlength } from "../../store/maxlength";
import { Mixin } from "/src/mixins/index.js";
import store from "/src/store/store.js";
import { country, aiAutoAIInterviewPlan } from "/src/store/url.js";
import options from "/src/validations/validations.js";

Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
	name: "ResumeEditPlan", // Renamed component
	mixins: [Mixin],
	components: {
		required_span,
	},
	data() {
		return {
            planId: null, // Added to store the ID
			maxV: '',
			counter: 0,
			menuCounter: 0,
			sideMenuCounter: 0,
			messageColor: "",
			submitted: false,
			err_msg: "",
			showAlert: false,
			dismissCountDown: 0,
			self: this,
			moduleCountry: country,
			module: aiAutoAIInterviewPlan,
			msg: "",
			typeOptions: [{
					'id': 'Company',
					'label': 'Company',
				},
				{
					'id': 'DirectCandidate',
					'label': 'Direct Candidate',
				},
			],
			platformOptions: [{
					'id': 0,
					'label': 'Web',
				},
				{
					'id': 1,
					'label': 'Android',
				},
				{
					'id': 2,
					'label': 'IOS',
				},
			],
            durationOptions: [{
					'id': 'Year',
					'label': 'Yearly',
				},
				{
					'id': 'Month',
					'label': 'Monthly',
				},
				{
					'id': 'Day',
					'label': 'Days',
				},
			],
			countryOptions: [],
			aiAutoaiInterviewPlan: {
				title: "",
				type: "",
                platform: [], // Changed to array for v-select with 'multiple'
                skuCodeAndroid: "",
                skuCodeIos: "",
                duration: "",
                durationValue: "",
				description: "",
				status: 1,
                minutes: ""
			},
            inputs: {
				web: [], // Initialized as empty arrays
				android: [],
				ios: [],
			},
			maxlength: {
				title: Maxlength.aiAutoAiInterviewPlan.title,
				description: Maxlength.aiAutoAiInterviewPlan.description,
				price: Maxlength.aiAutoAiInterviewPlan.price,
				offerPrice: Maxlength.aiAutoAiInterviewPlan.offerPrice,
                durationValue: Maxlength.aiAutoAiInterviewPlan.durationValue,
			},
		};
	},
	validations: {
		aiAutoaiInterviewPlan: {
			type: { required },
			title: { required },
			description: {
                required
            },
			platform: { required },
            minutes: { required },
            duration: { required },
            durationValue: {
                required,
				minValue: (function(value) {
					if (value === '') {
						return true;
					}
					return 1 <= value;
				}),
				maxValue: (function(value) {
					let self = this;
					// Check if duration is selected and has an id property
					const du = self.aiAutoaiInterviewPlan.duration && self.aiAutoaiInterviewPlan.duration.id; 
					if (du === "Year") { // Corrected from 'Yearly' to 'Year' based on durationOptions
						if (value <= 9999) {
							return true;
						}
						self.maxV = 9999;
						return false;
					} else if (du === "Month") { // Corrected from 'Monthly' to 'Month'
						if (value <= 12) {
							return true;
						}
						self.maxV = 12;
						return false;
					} else { // Assumes 'Day'
						if (value <= 365) {
							return true;
						}
						self.maxV = 365;
						return false;
					}
				}),
			}
		},
	},
	methods: {
		// ... existing methods (changedHasGST, addInput, subInput) ...
		changedHasGST(e) {
			let self = this;
			this.v = e.target.checked;
			if (this.v) {
				self.aiAutoaiInterviewPlan.hasGst = 1;
			} else {
				self.aiAutoaiInterviewPlan.hasGst = 0;
			}
		},
		addInput(platformKey) {
			this.inputs[platformKey].push({
				id: `${platformKey}_country${this.inputs[platformKey].length}`,
				price: '',
				offerPrice: '',
				hasGst: 0, // Set default to 0
				countryId: null, // Set default to null
			});
		},
		subInput(platformKey, id) {
			const index = this.inputs[platformKey].findIndex(i => i.id === id);
			if (index > 0) this.inputs[platformKey].splice(index, 1);
            // Ensure there is always at least one row per platform (optional)
            if (this.inputs[platformKey].length === 0) {
                 this.addInput(platformKey);
            }
		},
        // Renamed function to reflect 'Update' action
		onAiAutoAIInterviewPlanUpdate() {
			let self = this;
			this.$v.aiAutoaiInterviewPlan.$touch();
			if (this.$v.aiAutoaiInterviewPlan.$invalid) {
				self.submitted = false; //Enable Button
				this.submitStatus = "ERROR";
			} else {
				let self = this;
				self.submitted = true; //Disable Button
				let postData;
				postData = {
                    // Added planId for update API
                    "id": self.planId, 
					"title": self.aiAutoaiInterviewPlan.title,
					"skuCodeAndroid": self.aiAutoaiInterviewPlan.skuCodeAndroid,
                    "skuCodeIos": self.aiAutoaiInterviewPlan.skuCodeIos,
					"type": self.aiAutoaiInterviewPlan.type, // Ensure sending just the ID
					"platform": self.aiAutoaiInterviewPlan.platform, // Send array of platform IDs
					"duration": self.aiAutoaiInterviewPlan.duration, // Ensure sending just the ID
					"durationValue": self.aiAutoaiInterviewPlan.durationValue,
					"minutes": self.aiAutoaiInterviewPlan.minutes,
					"description": self.aiAutoaiInterviewPlan.description,
					"isActive": self.aiAutoaiInterviewPlan.status,
					"priceDetail": Object.keys(this.inputs).flatMap((platformKey) =>
						this.inputs[platformKey].map((i) => ({
							platform: platformKey, // 'web' | 'android' | 'ios'
							countryIds: i.countryId ? i.countryId.value : null, // Extract country ID from v-select object
                            countryId: i.countryId,
							price: i.price,
							offerPrice: i.offerPrice,
							isInclusive: 1,
							gstId: i.hasGst ? 1 : null,
							gstBusinessName: i.hasGst ? 'The Resourceful Network Private Limited' : null,
							gstNumber: i.hasGst ? '24AAMCT8780H1ZS' : null,
							hasGst: i.hasGst ? 1 : 0,
						}))
					),
				}
                // *** CHANGED: Use update API endpoint instead of create ***
                // Assuming your module.api.update is correctly defined
                const editId = this.$route.params.id;
                axios.post(self.editUrlApi(self.module, editId), postData).then((response) => {
                    self.submitted = false; //Enable Button
                    store.commit("showLoader", false); // Loader Off
                    if (response.data.code == 200) {
                        self.err_msg = response.data.message;
                        localStorage.setItem("notificationType", "success");
                        localStorage.setItem(
                            "notificationMessage",
                            response.data.message
                        );
                        // Navigate back to the list page
                        this.$router.push({ name: "AI & AutoAI Interview Plan List" });
                        self.dismissCountDown = 10;
                        self.messageColor = "success";
                    } else {
                        self.err_msg = response.data.message;
                        self.messageColor = "danger";
                        self.dismissCountDown = 10;
                    }
                })
                .catch(function(error) {
                    let data;
                    if (error.response.data.error) {
                        data = error.response.data.error.toString();
                    } else {
                        data = error.response.data.message;
                    }
                    self.err_msg = data;
                    self.dismissCountDown = 10;
                    self.messageColor = "danger";
                    self.submitted = false; //Enable Button
                });
            }
		},
		setAlert(value) {
			this.showAlert = value;
		},
        // Helper to map platform ID to key
        getPlatformKey(platformId) {
            return platformId === 0 ? 'web' : platformId === 1 ? 'android' : platformId === 2 ? 'ios' : null;
        }
	},
    mounted() {
        let self = this;
        store.commit("showLoader", false); // Loader Off
        self.dismissCountDown = 0;
        this.$root.$on("alert", (arg1, arg2) => {});
        if (localStorage.getItem("showAlert") !== "") {
            this.setAlert(true);
        }
        this.setAlert(false);
        localStorage.setItem("showAlert", "");

        // 1. Fetch Country Options first
        axios.get('/countries/lists').then((response) => {
            response.data.data.map(function(value) {
                self.countryOptions.push({ value: value.id, label: value.name });
            });
            // 2. Once countries are loaded, fetch the plan data
            const id = this.$route.params.id;
            if (id) {
                self.planId = id; // Store the ID
                
                // Assuming this.viewUrlApi is a mixin function to build the URL like: module.api.view + id
                axios.get(this.viewUrlApi(this.module, id)).then((response) => {
                    const plan = response.data.data;
                    
                    // A. Map main plan fields
                    this.aiAutoaiInterviewPlan.title = plan.title;
                    this.aiAutoaiInterviewPlan.skuCodeAndroid = plan.skuCodeAndroid || "";
                    this.aiAutoaiInterviewPlan.skuCodeIos = plan.skuCodeIos || "";
                    
                    // Map type (needs to be the object structure for v-select)
                    this.aiAutoaiInterviewPlan.type = this.typeOptions.find(opt => opt.id === plan.type) || { id: plan.type, label: plan.type };
                    
                    // Map duration (needs to be the object structure for v-select)
                    this.aiAutoaiInterviewPlan.duration = this.durationOptions.find(opt => opt.id === plan.duration) || { id: plan.duration, label: plan.duration };

                    this.aiAutoaiInterviewPlan.durationValue = plan.durationValue;
                    this.aiAutoaiInterviewPlan.minutes = plan.minutes;
                    this.aiAutoaiInterviewPlan.description = plan.description;
                    this.aiAutoaiInterviewPlan.status = plan.isActive;

                    // Map selected platforms (needs to be array of objects for v-select multiple)
                    // Assuming 'platforms' field in the response is an array of platform objects
                    const selectedPlatforms = plan.platforms ? plan.platforms.map(p => p.platform) : plan.platform || [];
                    this.aiAutoaiInterviewPlan.platform = this.platformOptions.filter(opt => selectedPlatforms.includes(opt.id));


                    // B. Map price details
                    // Initialize inputs to empty arrays before mapping
                    this.inputs = { web: [], android: [], ios: [] }; 

                    plan.platforms.forEach(p => {
                        const key = p.platform == 0 ? 'web' : p.platform == 1 ? 'android' : 'ios';
                        this.inputs[key] = p.prices.map((price, idx) => {
                            const countryObj = this.countryOptions.find(c => c.value === price.currencyId);
                            return {
                            id: `${key}_country${idx}`,
                            countryId: countryObj || { value: price.currencyId, label: `ID: ${price.currencyId}` },
                            price: price.price,
                            offerPrice: price.offerPrice,
                            hasGst: price.hasGst ? 1 : 0,
                            };
                        });
                    });
                    // if no prices were returned for them
                    Object.keys(this.inputs).forEach(key => {
                        if (this.inputs[key].length === 0) {
                            this.addInput(key);
                        }
                    });
                    store.commit("showLoader", false); // Loader Off after data is set

                }).catch((error) => {
                    console.error("Failed to fetch plan data:", error);
                    self.err_msg = 'Failed to load plan data.';
                    self.messageColor = "danger";
                    self.dismissCountDown = 10;
                    store.commit("showLoader", false); 
                });
            } else {
                 console.error("No ID found in route params for edit page.");
                 store.commit("showLoader", false); 
            }
        });
    },
    // ... existing watch block ...
    watch: {
		$route: {
			immediate: true,
			handler(route) {
				if (route.query && route.query.page) {
					this.activePage = Number(route.query.page);
				}
			},
		},
	},
};
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	margin-top: 60px;
}
</style>